import dayjs from 'dayjs';

export function formatEventDateRange(startDate, endDate, locale) {
    const dayjsLocale = locale?.split('-')[0] || dayjs.locale();
    const start = dayjs(startDate).locale(dayjsLocale);
    const end = dayjs(endDate).locale(dayjsLocale);
    const isFrench = dayjsLocale === 'fr';

    if (start.isSame(end, 'day') || end.diff(start, 'hour') < 18) {
        return isFrench
            ? start.format('D MMMM YYYY à HH:mm')
            : start.format('MMMM D, YYYY, h:mm A');
    }

    if (isFrench) {
        return `${start.format('D MMM')} - ${end.format('D MMM YYYY')}`;
    }

    return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
}
